import React from 'react';
import { Label } from 'semantic-ui-react';
import CarrierLogo from 'components/CarrierLogo/CarrierLogo';

export const getColumns = (renderActions = () => {}) => [
  {
    Header: 'Referencia',
    disableSortBy: true,
    width: 610,
    Cell: ({ row }) => (
      <div>
        {row.original.reference}
        {row.original.is_mixed && (
          <Label color="teal" style={{ marginLeft: '1em' }}>
            Múltiples OP
          </Label>
        )}
      </div>
    ),
  },
  {
    Header: 'Bultos',
    disableSortBy: true,
    accessor: 'packages',
    width: 60,
    textAlign: 'center',
    Cell: ({ value }) => value.length,
  },
  {
    Header: 'Agencia',
    disableSortBy: true,
    accessor: 'agency',
    width: 90,
    Cell: ({ value }) => <CarrierLogo code={value.agency_code} />,
  },
  {
    Header: 'Acciones',
    disableSortBy: true,
    textAlign: 'right',
    width: 100,
    Cell: ({ row }) => {
      return renderActions(row.original);
    },
  },
];
